import { useState } from 'react';
import { SORT_DIRECTION } from '../constants';

const getSortDirection = (isAsc) =>
  isAsc ? SORT_DIRECTION.DESC : SORT_DIRECTION.ASC;

export const usePaginatedDataTable = ({
  defaultRowsPerPage,
  defaultSortColumn,
  getTableData,
  onSelectRow,
}) => {
  const [sortColumn, setSortColumn] = useState(defaultSortColumn);
  const [sortDirection, setSortDirection] = useState(SORT_DIRECTION.ASC);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(defaultRowsPerPage);

  const fetchData = (updatedParams) => {
    const query = {
      page,
      rowsPerPage,
      sortColumn,
      sortDirection,
      ...updatedParams,
    };
    getTableData(query);
    onSelectRow && onSelectRow([]);
  };

  const handleSortOnChange = (column) => {
    const isCurrentSortColumn = column === sortColumn;
    const columnSortDirection = isCurrentSortColumn
      ? getSortDirection(sortDirection === SORT_DIRECTION.ASC)
      : SORT_DIRECTION.ASC;

    setSortDirection(columnSortDirection);
    setSortColumn(column);
    setPage(0);

    const query = {
      isTableReloadRequired: true,
      page: 0,
      sortColumn: column,
      sortDirection: columnSortDirection,
    };

    fetchData(query);
  };

  const handlePageOnChange = (_e, page) => {
    const query = {
      page,
    };
    setPage(page);
    fetchData(query);
  };

  const handleRowsPerPageOnChange = (e) => {
    const updatedRowsPerPage = Number(e.target.value);
    setRowsPerPage(updatedRowsPerPage);
    setPage(0);

    const query = {
      isTableReloadRequired: true,
      page: 0,
      rowsPerPage: updatedRowsPerPage,
    };
    fetchData(query);
  };

  return {
    handlePageOnChange,
    handleRowsPerPageOnChange,
    handleSortOnChange,
    page,
    rowsPerPage,
    sortColumn,
    sortDirection,
  };
};
